import React, { useState } from "react";
import { useEffect } from "react";
import { useAlert } from "react-alert";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import api from "../../api";
import { ConsentTerms } from "./consentTerms";
import userAction from "../../redux/users/action";

export const ConsentsModal = () => {
  const location = useLocation();
  const { setUser } = userAction;
  const dispatch = useDispatch();

  const userStore = useSelector((state) => state.userReducer);
  const alert = useAlert();
  const [data, setData] = useState({});
  const [loader, setLoader] = useState(false);

  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);

  const [showmoreText, setShowMoretext] = useState(false);

  const accept = async () => {
    try {
      const validatorsResponse = validators();

      if (validatorsResponse) {
        return alert.show(validatorsResponse);
      }
      setLoader(true);
      // console.log(data);
      const payload = {
        termsAccepted: data.termsAccepted,
        signature: data.signature,
      };
      const response = await api.addConsents(payload);
      // console.log(response);
      if (response?.success) {
        handleCloseMore();
        setLoader(false);
        let updatedData = userStore?.users;
        updatedData.user.termsAccepted = data.termsAccepted;
        updatedData.user.signature = data.signature;
        dispatch(setUser(updatedData));

        alert.show("Thanks for submission");
      }
    } catch (error) {
      console.log(error?.message);
      alert.show("Something went wrong");
    }
  };

  const validators = () => {
    if (!data?.signature) {
      return "Please add signature";
    }
    if (data?.signature.length > 30) {
      return "Max 30 character allowed in signature";
    }
    if (!data?.termsAccepted) {
      return "Please read and  accept terms and conditions";
    }

    return false;
  };

  useEffect(() => {
    // let check = localStorage.getItem("disclaimer");

    if (userStore?.users?.user?._id || !location.pathname.includes("admin")) {
      if (!userStore?.users?.user?.termsAccepted) {
        handleShowMore();
      }
    }
  }, [userStore?.users]);

  const onTextChange = (e, type) => {
    if (e.target.name == "terms") {
      setData({ ...data, termsAccepted: e.target.checked });
    } else {
      setData({ ...data, [e.target.name]: e.target.value });
    }
  };

  return (
    <Modal size="lg" show={showMore} centered>
      <Modal.Body>
        <div className="otpModalMain broadcastModal">
          <div className="closeIcon" onClick={handleCloseMore}>
            <i className="fa-solid fa-xmark" />
          </div>
          <div className="showMoreModalM">
            <div className="showMoreModal pdfMain">
              <ConsentTerms
                showmore={showmoreText}
                setShowMore={setShowMoretext}
              />
              <div className="contact-form mt-4 m-0 p-0">
                <div className="form-group ">
                  <label>
                    By typing your full name below, you agree that it serves as
                    your digital signature and confirm that you accept our Terms
                    & Conditions.{" "}
                  </label>
                  <input
                    onChange={(e) => onTextChange(e)}
                    type="text"
                    name="signature"
                    required
                    placeholder="Signature"
                    className="form-control ng-dirty ng-invalid ng-touched"
                  />
                </div>
                <div className="acceptTerms">
                  <input
                    type="checkbox"
                    name="terms"
                    id=""
                    onChange={(e) => onTextChange(e)}
                    className="me-2"
                  />
                  I have read and agree to the{" "}
                  <a
                    onClick={() => setShowMoretext(true)}
                    style={{ color: "#0d6efd", cursor: "pointer" }}
                  >
                    Terms & Conditions
                  </a>
                </div>
              </div>
            </div>
            <div className="mt-4">
              <button className="themeBtn mx-auto" onClick={accept}>
                Accept
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
